import { render, staticRenderFns } from "./LocusZoomCoaccessibilityPanel.vue?vue&type=template&id=1e3403f4&"
import script from "./LocusZoomCoaccessibilityPanel.vue?vue&type=script&lang=js&"
export * from "./LocusZoomCoaccessibilityPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e3403f4')) {
      api.createRecord('1e3403f4', component.options)
    } else {
      api.reload('1e3403f4', component.options)
    }
    module.hot.accept("./LocusZoomCoaccessibilityPanel.vue?vue&type=template&id=1e3403f4&", function () {
      api.rerender('1e3403f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lz/panels/LocusZoomCoaccessibilityPanel.vue"
export default component.exports